export default __webpack_public_path__ + "static/media/location.62b1767c.svg";